import { colors } from '@material-ui/core';
//eslint-disable-next-line
export default {
  root: {
    backgroundColor: colors.grey[50]
  }
};
